// Post-auth deep-link landing, shared by the OAuth-return effect and
// every email/password path in Auth.tsx (PROP-171). Pure + framework-
// free so the routing decision is unit-tested without rendering Auth.

// sanitizeNext validates a raw ?next= value: it must be an app-relative
// path — it starts with "/" but NOT "//" (which the browser treats as a
// protocol-relative URL to another origin, an open-redirect vector).
// Anything else (absolute URL, bare host, empty, null) collapses to "".
export function sanitizeNext(raw: string | null | undefined): string {
  const v = raw ?? "";
  return v.startsWith("/") && !v.startsWith("//") ? v : "";
}

// resolveLanding picks the post-auth destination. Prefer a sanitized
// deep link (safeNext) when it's reachable by this user; a non-pro user
// sent to /pro/* would just be bounced straight back out by RequirePro,
// so fall back to their role home there. `role` accepts either the
// backend role ("pro") or the onboarding role ("agent") — both land on
// the pro home; everything else lands on /chat.
export function resolveLanding(safeNext: string, role: string | null | undefined): string {
  const isPro = role === "pro" || role === "agent";
  const home = isPro ? "/pro/dashboard" : "/chat";
  if (safeNext && (isPro || !safeNext.startsWith("/pro"))) return safeNext;
  return home;
}
